import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crowns } from '../../assets/Crowns.tsx';
import { Logo } from '../../assets/Logo.tsx';
import { Button } from '../../components/Button/Button.tsx';
import { Footer } from '../../components/Footer/Footer.tsx';
import { Header } from '../../components/Header/Header.tsx';
import './Home.scss';
import { Demo } from './components/Demo.tsx';
import { FlyingBids } from './components/FlyingBids.tsx';
import { ImageSection } from './components/ImageSection/ImageSection.tsx';

export const Home = () => {
    const navigate = useNavigate();

    const goToGame = () => {
        navigate('/licytacja');
    };
    const goToBackofficeInfo = () => {
        navigate('/utworz-grupe');
    };

    return (
        <div className="home">
            <Header />
            <div className="section__hero-wrapper">
                <img className="section__hero__bg"
src="./images/hero-bg.png"
alt="Cards" />
                <div className="section__hero">
                    <div className="home__hero">
                        <div className="home__hero--first">
                            <span>Graj.</span>
                        </div>
                        <div className="home__hero--sec">
                            <span>Licytuj.</span>
                        </div>
                        <div className="home__hero--third">
                            <span>Wygrywaj.</span>
                        </div>
                    </div>
                    <p className="section__desc">
                        <span className="section__desc--licytapka">Licytapka</span> to Twoja partnerka <br />w nauce licytacji brydżowych
                    </p>
                    <Button onClick={goToGame}
text="Przetestuj swoją wiedzę" />
                </div>
            </div>
            <Demo />
            <div className="home__section home__section--bids">
                <FlyingBids direction="right" />
                <div className="home__logo-wrapper">
                    <Logo fill="#000" />
                    <p className="home__logo-desc">Twoja partnerka w licytacji</p>
                </div>
                <FlyingBids direction="left" />
            </div>
            <ImageSection variant="white">
                <img src="./images/custom-cards7.jpg"
alt="seq-bids" />
                <div className="imageSection__content">
                    <h3 className="section__title">Nauka licytacji</h3>
                    <p className="section__desc">Licytacje w grupie ogólnej są przygotowane na podstawie systemu Wspólny Język. Zapoznaj się z nim przed rozpoczęciem testów. </p>
                    <Button variant="ghost-black"
onClick={() => navigate('/nauka')}
text="Ucz się" />
                </div>
            </ImageSection>

            <ImageSection variant="red-noPb">
                <div className="imageSection__content">
                    <h3 className="section__title">Zbieraj punkty</h3>
                    <p className="section__desc">Za poprawnie wykonane testy otrzymasz punkty! Zbieraj je, by osiągnąć wyższą rangę!</p>
                    <Button variant="ghost-white-red"
onClick={() => navigate('/profil')}
text="Zobacz swoje statystyki" />
                </div>
                <Crowns />
            </ImageSection>
            <ImageSection>
                <img className="home__backoffice"
src="./images/tests.png"
alt="" />
                <div className="imageSection__content">
                    <h3 className="section__title">Uczysz brydża?</h3>
                    <p className="section__desc">Jeżeli chcesz tworzyć własne przypadki testowe, przeczytaj instrukcję i utwórz własną grupę.</p>

                    <Button variant="ghost-white-green"
onClick={goToBackofficeInfo}
text="Stwórz własne testy" />
                </div>
            </ImageSection>
            <Footer />
        </div>
    );
};
